document.addEventListener('DOMContentLoaded', function() {
const swiper = new Swiper('.acc_nd_landing_30_02_rowswiper', {
loop: true,
spaceBetween: 12,
slidesPerView: 2, // default for mobile (<768)
autoplay: {
delay: 2000,
},
speed: 800,
breakpoints: {
360: {
slidesPerView: 1.7,
spaceBetween: 8,
},
500: {
slidesPerView: 2,
spaceBetween: 8,
},
768: {
slidesPerView: 3,
spaceBetween: 20,
},
1200: {
slidesPerView: 4,
spaceBetween: 20,
},
1400: {
slidesPerView: 6,
spaceBetween: 20,
},
},
});


});